/**
 * Admin — Tool Registry page — /admin/tools
 *
 * See AdminNav for the full list of admin sections.
 */
import React from 'react';
import { ToolRegistry } from '@/components/admin/ToolRegistry';
import { AdminPageShell } from '../_components/AdminPageShell';

export const AdminToolsPage: React.FC = () => (
  <AdminPageShell title="Tool Registry">
    <ToolRegistry />
  </AdminPageShell>
);
